const routes = [
    {
        path: "/dashboard",
        name: "dashboard_index",
        component: () => import("../views/dashboard/index.vue"),
        meta: { h5Header: true, h5TitleKey: "dashboard.index.title" },
        children: [
            {
                name: "accessory_list",
                path: "accessory",
                component: () => import("../views/dashboard/accessory_list.vue"),
                meta: { h5TitleKey: "dashboard.listTitle.accessory" },
            },
            {
                name: "accessory_single",
                path: "accessory/:id",
                component: () => import("../views/dashboard/accessory_single.vue"),
                meta: { h5TitleKey: "dashboard.detail.accessory" },
            },
            {
                name: "backup_list",
                path: "backup",
                component: () => import("../views/dashboard/backup_list.vue"),
                meta: { h5TitleKey: "dashboard.listTitle.backup" },
            },
            {
                name: "backup_single",
                path: "backup/:id",
                component: () => import("../views/dashboard/backup_single.vue"),
                meta: { h5TitleKey: "dashboard.detail.backup" },
            },
            {
                name: "repair_list",
                path: "repair",
                component: () => import("../views/dashboard/repair_list.vue"),
                meta: { h5TitleKey: "dashboard.listTitle.repair" },
            },
            {
                name: "repair_single",
                path: "repair/:id",
                component: () => import("../views/dashboard/repair_single.vue"),
                meta: { h5TitleKey: "dashboard.detail.repair" },
            },
            {
                name: "return_list",
                path: "return",
                component: () => import("../views/dashboard/return_list.vue"),
                meta: { h5TitleKey: "dashboard.listTitle.return" },
            },
            {
                name: "profile",
                path: "profile",
                component: () => import("../views/profile"),
                meta: { h5TitleKey: "setting.profileTitle" },
            },
            {
                name: "quickrp_list",
                path: "quickrp",
                component: () => import("../views/dashboard/quickrp_list.vue"),
                meta: { h5TitleKey: "dashboard.listTitle.quickrp" },
            },
            {
                name: "quickrp_single",
                path: "quickrp/:id",
                component: () => import("../views/dashboard/quickrp_single.vue"),
                meta: { h5TitleKey: "dashboard.detail.quickrp" },
            },
        ],
    },
];

export default routes;
